module.exports = __webpack_public_path__ + "static/media/client-advocate-wi.b9b8d326.png";